import myzod, { Infer } from 'myzod'

export enum ChargeType {
  CREDIT = 'CREDIT',
  DEBIT = 'DEBIT',
}

export const ChargeBreakdownSchema = myzod.object({
  contractorFee: myzod.number(),
  systemFee: myzod.number(),
})

export const ChargeEventSchema = myzod.object({
  chargeType: myzod.enum(ChargeType),
  description: myzod.string(),
  chargeBreakdown: ChargeBreakdownSchema,
  chargeTo: myzod.string(),
  chargedOn: myzod.string(),
  contractorId: myzod
    .string()
    .pattern(/^User#/)
    .optional(),
})

export type ChargeEvent = Infer<typeof ChargeEventSchema>
